<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Presenting Companies
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
      { logo: require('@/assets/logos/zeebu.png'), class: 'full-logo', name: 'Zeebu', url: 'http://zeebu.com/' },
      { logo: require('@/assets/logos/midnight.svg'), class: 'full-logo', name: 'Midnight', url: 'https://midnight.network/' },
      { logo: require('@/assets/logos/slash.svg'), class: 'full-logo', name: 'Slash Vision Labs', url: 'https://slash.vision/' },
      { logo: require('@/assets/logos/solana.svg'), class: 'full-logo', name: 'Solana Foundation', url: 'https://solana.org/' },
      { logo: require('@/assets/logos/ethereum.svg'), class: 'logo', name: 'Ethereum Foundation', url: 'https://ethereum.org/en/' },
      { logo: require('@/assets/logos/iohk.png'), class: 'full-logo', name: 'Input Output', url: 'https://iohk.io/' },
      { logo: require('@/assets/logos/theoriq.svg'), class: 'full-logo', name: 'Theoriq', url: 'https://www.theoriq.ai/' },
      { logo: require('@/assets/logos/xitadel.svg'), class: 'full-logo', name: 'Xitadel', url: 'https://xitadel.fi/' },
      { logo: require('@/assets/logos/zeus.svg'), class: 'full-logo', name: 'Zeus Network', url: 'https://zeusnetwork.xyz/' },
      { logo: require('@/assets/logos/Cointelegraph.png'), class: 'full-logo', name: 'Cointelegraph', url: 'https://cointelegraph.com/' },
      { logo: require('@/assets/logos/jupiter.png'), class: 'logo circle', name: 'Jupiter', url: 'https://jup.ag/' },
      { logo: require('@/assets/logos/aww.svg'), class: 'logo ibc', name: 'Aww', url: 'https://aww.tokyo/' },
      { logo: require('@/assets/logos/abstract.png'), class: 'logo circle', name: 'Abstract', url: 'https://www.abs.xyz/' },
      { logo: require('@/assets/logos/ivc.png'), class: 'full-logo', name: 'IVC', url: 'https://www.ivcrypto.io/' },
      { logo: require('@/assets/logos/antler.svg'), class: 'full-logo', name: 'Antler Ibex KK', url: 'https://www.antler.co/' },
      { logo: require('@/assets/logos/monke.svg'), class: 'full-logo', name: 'MonkeDAO', url: 'https://monkedao.io/' },
      { logo: require('@/assets/logos/hashkey.png'), class: 'full-logo', name: 'HashKey Capital', url: 'https://hashkey.capital/' },
      { logo: require('@/assets/logos/story.png'), class: 'logo circle', name: 'Story Foundation', url: 'https://www.story.foundation/' },
      { logo: require('@/assets/logos/intmax.png'), class: 'full-logo', name: 'INTMAX', url: 'https://intmax.io/' },
      { logo: require('@/assets/logos/071.png'), class: 'full-logo', name: '071 Labs', url: 'http://071labs.io/' },
      { logo: require('@/assets/logos/emurgo.svg'), class: 'full-logo', name: 'EMURGO', url: 'https://www.emurgo.io/' },
      { logo: require('@/assets/logos/mystenlabs.svg'), class: 'full-logo', name: 'Mysten Labs/Sui', url: 'https://www.mystenlabs.com/' },
      { logo: require('@/assets/logos/kaia.svg'), class: 'logo', name: 'Kaia', url: 'https://www.kaia.io/' },
      { logo: require('@/assets/logos/fracton.png'), class: 'full-logo', name: 'Fracton Ventures', url: 'https://fracton.ventures/' },
      { logo: require('@/assets/logos/backstage.svg'), class: 'full-logo', name: 'Backstage', url: 'https://backstage.global/' },
      { logo: require('@/assets/logos/own.png'), class: 'full-logo', name: 'Own. App', url: 'https://www.ownapp.co/' },
      { logo: require('@/assets/logos/raiinmaker.png'), class: 'full-logo', name: 'Raiinmaker', url: 'https://www.raiinmaker.com/' },
      { logo: require('@/assets/logos/pact.png'), class: 'logo', name: 'Pact Swap', url: 'https://pactswap.io/' },
      { logo: require('@/assets/nashville/sponsors/kredete.png'), class: 'full-logo', name: 'Kredete', url: 'https://www.kredete.com/' },
      { logo: require('@/assets/logos/zkalyx.png'), class: 'full-logo', name: 'Zkalyx', url: 'https://www.zkalyx.com/' },
      { logo: require('@/assets/logos/americanfortress.svg'), class: 'full-logo', name: 'American Fortress', url: 'https://americanfortress.io/' },
      { logo: require('@/assets/logos/planck.svg'), class: 'full-logo', name: 'Planck', url: 'https://www.plancknetwork.com/' }
    ]);
    return {
      partners
    };
  },
};
</script>